import ReactDOM from 'react-dom';
import Root from '../tools/maandlasten-bij-aflossen/index';

import '../../sass/apps/maandlasten-bij-aflossen/maandlasten-bij-aflossen.scss';

if (document.getElementById('maandlasten-bij-aflossen-app')) {
  ReactDOM.render(<Root />, document.getElementById('maandlasten-bij-aflossen-app'));
}
